import React, { Component } from 'react';


import { make_cols } from './MakeColumns';

import './styles.css';

class UploadButtonAltVendor extends Component {

    constructor(props) {
        super(props);
        this.state = {
          file: {},
          data: [],
          cols: []
        }
        this.handleFile = this.handleFile.bind(this);
        this.handleChange = this.handleChange.bind(this);
      }

    handleChange = (e) => {
        this.props.openNotification(true);
        const files = e.target.files;
        if (files && files[0]) {
            this.setState({ file: files[0] });
            setTimeout(() => { this.handleFile(); }, 2000);
        }
        e.target.value = null;
    };
     
    handleFile() {
        /* Boilerplate to set up FileReader */
        const reader = new FileReader();
        const rABS = !!reader.readAsBinaryString;

        let isItemId = false;
        let isSuffix = false;
        let isPoNumber = false;
        let isQty = false;
     
        reader.onload = async (e) => {

          const XLSX = await import("xlsx");
          
          /* Parse data */
          const bstr = e.target.result;
          const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array', bookVBA : true });
          /* Get first worksheet */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          if(ws.A1.h == "itemId" || ws.B1.h == "itemId" || ws.C1.h == "itemId" || ws.D1.h == "itemId")  isItemId = true;
          if(ws.A1.h == "purchaseOrderNumber" || ws.B1.h == "purchaseOrderNumber" || ws.C1.h == "purchaseOrderNumber" || ws.D1.h == "purchaseOrderNumber") isPoNumber = true;
          if(ws.A1.h == "suffix" || ws.B1.h == "suffix" || ws.C1.h == "suffix" || ws.D1.h == "suffix") isSuffix = true;
          if(ws.A1.h == "qty" || ws.B1.h == "qty" || ws.C1.h == "qty" || ws.D1.h == "qty") isQty = true;
          if(isItemId == false || isSuffix == false || isPoNumber == false || isQty == false) return this.props.errorHeader(true)
          /* Convert array of arrays */
          const data = XLSX.utils.sheet_to_json(ws);
          /* Update state */
          this.setState({ data: data, cols: make_cols(ws['!ref']) }, () => {
          const excelJson = JSON.parse(JSON.stringify(this.state.data));
          const asnObject = excelJson.map(({ "purchaseOrderNumber": purchaseOrderNumber, "suffix": suffix, "itemId": itemId, "qty": qty}) => 
          ({ purchaseOrderNumber, suffix, itemId, qty}));
          this.props.onGetExcelData(asnObject);  
         });
        };
        if (rABS) {
          reader.readAsBinaryString(this.state.file);
        } else {
          reader.readAsArrayBuffer(this.state.file);
        };
    }

    buttonHandler = () => {
        document.getElementById('fileInput').click();
    }

    render() {
        return (
            <div>
                <input id="fileInput" type="file" className="input-file" accept=".xls, .xlsx" onChange={this.handleChange}/>
                <input type="button" value="Upload" onClick={this.buttonHandler} className="upload-button"/>
            </div>
        );
    }
 
}

export default UploadButtonAltVendor;